import { RTEContent } from 'module/ui/components/atoms/rich-text-editor-input/html-content';
import { faPenNib } from '@fortawesome/pro-solid-svg-icons';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Section } from '../section-ui';
import { SectionTitle } from '../section-ui/title';

interface Props {
  notes: string;
}
export const EnhanceWithNotesSection: FC<Props> = ({ notes }) => {
  return (
    <Section
      title={
        <SectionTitle
          title={
            <FormattedMessage id="ask_ai_command_processor.request.section.notes.title" />
          }
          icon={<SectionTitle.Icon icon={faPenNib} />}
        />
      }
      contentBackgroundColor={'var(--purple-20)'}
      content={<RTEContent value={notes} />}
    />
  );
};
